import Modal from '../modal/Modal';
import './presenceSettingsModal.css';

const TOOLTIP_COPY =
  'Presence = faster routing. See funded tasks earlier and get live pings when work is ready.';

export const presenceTooltipCopy = TOOLTIP_COPY;

export default function PresenceSettingsModal({ open, onClose }) {
  return (
    <Modal openModal={open}>
      <div className="presenceSettingsModal" role="dialog" aria-label="Presence">
        <button
          type="button"
          className="presenceSettingsModal__close"
          onClick={onClose}
          aria-label="Close presence"
        >
          x
        </button>
        <div className="presenceSettingsModal__title">Presence</div>
        <div className="presenceSettingsModal__tagline">Get work faster.</div>
        <p className="presenceSettingsModal__body">
          Presence gives you priority discovery and live pings for funded
          LocalOps tasks near you.
        </p>
        <p className="presenceSettingsModal__body">
          When you are present, the system routes opportunity to you sooner - so
          you spend less time checking and more time getting paid.
        </p>
        <div className="presenceSettingsModal__ethics">
          Presence never hides work. It simply reduces latency.
        </div>
        <div className="presenceSettingsModal__beta">
          Presence is currently enabled during beta.
        </div>
        {/*
          Future upsell copy (feature flagged):
          Headline: Be first to see funded tasks.
          Body: Presence reduces the time between a task being posted and getting paid.
          You'll see new work sooner and get live pings when tasks match your location.
          Trust line: Presence doesn't block anyone from seeing work - it simply routes it earlier.
        */}
      </div>
    </Modal>
  );
}
